import { Box, Typography, Tab, Tabs } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Filter from '../components/Payments/Filter';
import { useSearchParams } from 'react-router-dom';
import getFilters from '../components/Payments/Filters';
import TableComponent from '../components/Payments/TableComponent';

function tabPick(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Payments = () => {
  const [tab, setTab] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState({
    dateFromConfirmation: null,
    dateToConfirmation: null,
    dateFromPayment: null,
    dateToPayment: null,
    yearOfConfirmation: 0,
    paidStatus: '',
    afm: '',
  });

  const [searchFilters, setSearchFilters] = useState(null);

  const handleTabChange = (event, newValue) => {
    setFilters({
      dateFromConfirmation: null,
      dateToConfirmation: null,
      dateFromPayment: null,
      dateToPayment: null,
      yearOfConfirmation: 0,
      paidStatus: '',
      afm: '',
    });
    setSearchFilters(null); //clear filters
    setTab(newValue);
    const tabKey = newValue === 0
      ? 'unpaid'
      : 'paid';
    setSearchParams({ tab: tabKey });
  };

  useEffect(() => {
    const initialTab = searchParams.get('tab');

    if (!initialTab) {
      setSearchParams({ tab: 'unpaid' });
    } else if (initialTab === 'paid') {
      setTab(1);
    }
  }, []);

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <Box
        component='section'
        sx={{
          p: 2,
          mt: 3,
          ml: 3,
          width: '90%',
        }}
      >
        <Typography variant='h3'> Επισκόπηση Εισπράξεων </Typography>
      </Box>
      <div
        style={{
          display: 'flex',
          width: '100%',
          flexWrap: 'wrap',
          height: '95%',
        }}
      >
        <Filter
          filters={getFilters({ filters, setFilters })}
          setFilterState={setFilters}
          filterState={filters}
          setSearchFilters={setSearchFilters}
        />

        <Box
          sx={{
            width: {
              xl: 'calc(100% - 10em)',
              lg: 'calc(100% - 10em)',
              md: '100%',
              sn: '100%',
            },
            display: 'flex',
            flexDirection: 'column',
            ml: {
              xl: '20em',
              lg: '20em',
              md: 0,
              sn: 0,
            },
          }}
        >
          <Box
            sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}
          >
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={tab} onChange={handleTabChange}>
                <Tab label='Απληρωτες' key='unpaid'
                  {...tabPick(0)} />
                <Tab label='Αποπληρωμενες' key='paid'
                  {...tabPick(1)} />
              </Tabs>
            </Box>
          </Box>
          <TableComponent
            searchFilters={searchFilters}
            setSearchFilters={setSearchFilters}
          />
        </Box>
      </div>
    </Box>
  );
};

export default Payments;
